module.exports = __webpack_public_path__ + "img/homewords.6a23f0bb.png";